import React from "react";

const NotificationPage = () => {
  return <></>;
};

export default NotificationPage;
